import { render, staticRenderFns } from "./SuperPaleListCurrent.vue?vue&type=template&id=f5ac2752"
import script from "./SuperPaleListCurrent.vue?vue&type=script&lang=js"
export * from "./SuperPaleListCurrent.vue?vue&type=script&lang=js"
import style0 from "./SuperPaleListCurrent.vue?vue&type=style&index=0&id=f5ac2752&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports